export default __webpack_public_path__ + "static/media/bg.805a353b.png";